





















































































import FleetManagerTreeDialog from "@/components/fleet/FleetManagerTreeDialog.vue";
import MyDamageDetailSideCard from "@/components/report/user/MyDamageDetailSideCard.vue";
import ErrorCard from "@/components/utility/ErrorCard.vue";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { MrfiktivVehicleViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { VehicleFleetModule } from "@/store/modules/fleet/vehicle-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { ReportModule } from "@/store/modules/report.store";
import { VehicleModule } from "@/store/modules/vehicle.store";
import { PredefinedFilterType } from "@/views/event/filter/event.filter";
import { debounce } from "debounce";
import { Component, Vue } from "vue-property-decorator";
import { IControlElements } from "@/lib/types/tableWrapper";
import { $t } from "@/lib/utility/t";

@Component({
  components: {
    LayoutReportWithBanner,
    PaginatedTable,
    MyDamageDetailSideCard,
    FleetManagerTreeDialog,
    ErrorCard,
    MHeader
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class FleetVehicleView extends Vue {
  readonly store = VehicleFleetModule;

  FleetManagerModule = FleetManagerModule;

  loading = false;
  selectedId: string | null = null;

  updateTableKey = "";

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: this.$t("nav.FleetTableView.description"),
      disabled: false,
      exact: true,
      to: {
        name: "FleetAnalyticsView",
        params: {}
      }
    });

    breadCrumbs.push({
      text: this.$t("common.nouns.vehicle"),
      disabled: false,
      exact: false,
      to: {
        name: "FleetVehicleView",
        params: {}
      }
    });

    return breadCrumbs;
  }

  get predefinedFilter(): PredefinedFilterType[] {
    return [];
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  get fleetIds() {
    return UserModule.fleetPermission?.filter(p => p.partnerId === this.partnerId).map(p => p.fleetId);
  }

  get fleetId() {
    return FleetManagerModule.selectedFleetId;
  }

  get items() {
    return VehicleFleetModule.filteredAndSorted;
  }

  get totalItems() {
    return VehicleFleetModule.totalItems;
  }

  get i18n() {
    return this.$t("views.fleet.FleetVehicleListView");
  }

  get chips(): IAction[] {
    return [
      {
        text: `${this.totalItems} ${this.$t("common.nouns.vehicles")}`,
        key: "fahrzeuge",
        icon: "mdi-car"
      }
    ];
  }

  get controlElements(): IControlElements[] {
    const controlElements: IControlElements[] = [
      {
        icon: "mdi-car-wrench",
        text: $t("report.ThgChargingStationDetailCard.toDetail"),
        action: (selectedItem: MrfiktivVehicleViewModelGen) => this.openDamage(selectedItem)
      }
    ];

    return controlElements;
  }

  get fleetIdList() {
    return UserModule.fleetPermission?.filter(p => p.partnerId === this.partnerId).map(p => p.fleetId) ?? [];
  }

  get uniqueFleetIds() {
    const fleetIds = new Set();

    this.fleetIdList.forEach(i => fleetIds.add(i));

    return fleetIds.values();
  }

  get uniqueFleetCount() {
    return Array.from(this.uniqueFleetIds).length;
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];
    if (this.uniqueFleetCount > 1) {
      actions.push({
        text: this.$t("views.report.fleet.FleetAnalyticsView.selectionDialog.openFleetTree").toString(),
        key: "fleet",
        exec: () => ((this.$refs.dialog as unknown) as IDialog)?.open()
      });
    }
    return actions;
  }

  get headers() {
    return [
      {
        text: this.$t("objects.vehicle.timestamp.created"),
        align: "left",
        width: 120,
        value: "timestamp.created"
      },
      {
        text: this.$t("objects.vehicle.state"),
        align: "left",
        width: 165,
        value: "state"
      },
      {
        text: this.$t("common.nouns.vehicle"),
        align: "left",
        value: "numberplate"
      },
      { text: "", align: "end", value: "controls", width: 120, sortable: false }
    ];
  }

  get selectedFleetIds() {
    return FleetManagerModule.selectedFleetIds;
  }

  getState(item: MrfiktivVehicleViewModelGen) {
    if (!item.state) {
      return { color: "grey lighten-4", label: "" };
    }

    return VehicleModule.stateMap.get(item.state);
  }

  getInitialRegistrationDate(item: MrfiktivVehicleViewModelGen): string | undefined {
    const date = this.getInitialRegistrationDateRaw(item);
    if (!date) {
      return undefined;
    }

    const day = `${date.getDate()}`.padStart(2, "0");
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  private getInitialRegistrationDateRaw(item: MrfiktivVehicleViewModelGen): Date | undefined {
    if (!item?.registration) {
      return undefined;
    }

    const { initialRegistrationDay, initialRegistrationMonth, initialRegistrationYear } = item.registration;

    if (!initialRegistrationDay || !initialRegistrationMonth || !initialRegistrationYear) {
      return undefined;
    }

    const day = parseInt(initialRegistrationDay, 10);
    const month = parseInt(initialRegistrationMonth, 10);
    const year = parseInt(initialRegistrationYear, 10);

    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return undefined;
    }

    return new Date(year, month - 1, day);
  }

  get vehicleDownloadHeaders(): Map<string, string> {
    const headers = new Map<string, string>();

    headers.set("createdAt", this.$t("objects.vehicle.timestamp.created").toString());
    headers.set("status", this.$t("objects.vehicle.state").toString());
    headers.set("numberplate", this.$t("objects.vehicle.numberplate").toString());
    headers.set("vin", this.$t("objects.vehicle.identificationnumber").toString());
    headers.set("initialRegistrationDate", this.$t("objects.vehicle.registration.firstregistration").toString());
    headers.set("manufacturerType", this.$t("objects.vehicle.registration.manufacturerName").toString());
    headers.set("manufacturerDescription", this.$t("objects.vehicle.registration.manufacturerDescription").toString());
    headers.set("fuelType", this.$t("objects.vehicle.registration.fuelType").toString());
    headers.set("ownership", this.$t("objects.vehicle.ownership").toString());

    return headers;
  }

  get vehicleDownloadConfig() {
    return {
      transform: (item: MrfiktivVehicleViewModelGen): Record<string, any> => {
        const initialRegistrationDate = this.getInitialRegistrationDateRaw(item);

        return {
          createdAt: item.timestamp?.created ? new Date(item.timestamp.created) : undefined,
          status: item.state ? this.$t(`enums.VehicleStateEnum.${item.state}`) : "",
          numberplate: item.numberplate,
          vin: item.identificationnumber,
          initialRegistrationDate: initialRegistrationDate,
          manufacturerType: item.registration?.manufacturerName,
          manufacturerDescription: item.registration?.manufacturerDescription,
          fuelType: item.registration?.fuelType,
          ownership: item.ownership ? this.$t(`enums.VehicleOwnershipStatusEnum.${item.ownership}`).toString() : ""
        };
      },
      headers: this.vehicleDownloadHeaders
    };
  }

  async load() {
    if (!this.fleetId) {
      return;
    }

    this.loading = true;

    try {
      await FleetManagerModule.getFleetTree({ partnerId: this.partnerId, fleetId: this.fleetId });
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }

  async openDetail(item: MrfiktivVehicleViewModelGen) {
    this.$log.debug(item);
    if (!this.fleetId) {
      return;
    }

    this.loading = true;

    try {
      const vehicle = await VehicleFleetModule.getOne({
        partnerId: this.partnerId,
        fleetId: this.fleetId,
        id: item.id
      });
      this.selectedId = vehicle.id;
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }

  async openDamage(item: MrfiktivVehicleViewModelGen) {
    this.$log.debug(item);
    if (!this.fleetId) {
      return;
    }

    this.loading = true;

    try {
      await this.$router.push({ name: "FleetDamageView", query: { vehicleId: item.id } });
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }

  debounceUpdateTable = debounce(this.updateTable, 200);
  updateTable() {
    // We filter using base query. The data access layer has to be cleared of all "old" results.
    this.store.reset();
    this.updateTableKey = FleetManagerModule.selectedFleetIds.join("_");
  }
}
